<tlc-app-shell-topbar-button
  (click)="dropdown.openAt(dropdownTrigger)"
  [iconName]="'help-outline'"
  [iconNameActive]="'help'"
  [isActive]="isActive() || dropdown.open"
  #dropdownTrigger="rtOverlayOrigin"
  rt-overlay-origin
/>

@if (hasAnyUnread() && !dropdown.open) {
  <rt-dot color="notifications" size="small" class="help-button-dot" />
}

<ng-template
  #dropdown="rtConnectedOverlay"
  rt-connected-overlay
  hasBackdrop
  (backdropClick)="dropdown.open = false"
>
  <rt-dropdown [width]="DropdownWidth.Small">
    @if (showGetStarted()) {
      <rt-dropdown-item (click)="onGetStarted(dropdown)">
        <rt-icon prefix name="rocket" size="medium" />
        <span margin-left-small-x>{{
          'app.getting_started.step_get_started.title' | translate
        }}</span>
      </rt-dropdown-item>
    }

    <rt-dropdown-item [href]="resolvedHelpCenterUrl()" hrefTarget="_blank">
      <rt-icon prefix name="book-open-page-variant" size="medium" />
      <span margin-left-small-x>{{ 'app.support_fab.go_to_help_center' | translate }}</span>
    </rt-dropdown-item>

    <rt-dropdown-item
      [href]="productUpdatesUrl()"
      hrefTarget="_blank"
      (click)="onProductUpdatesClick(dropdown)"
    >
      <rt-icon prefix name="browse-activity" size="medium" />
      <span margin-left-small-x>{{ 'app.page_titles.setup_product_updates' | translate }}</span>
      @if (isUnread()) {
        <rt-dot suffix color="notifications" size="small" class="product-updates-dot" />
      }
    </rt-dropdown-item>

    <rt-dropdown-item [href]="shareFeedbackUrl()" hrefTarget="_blank">
      <rt-icon prefix name="add-reaction" size="medium" />
      <span margin-left-small-x>{{ 'app.common.share_feedback' | translate }}</span>
    </rt-dropdown-item>

    @if (showContactSupport()) {
      <rt-dropdown-item (click)="onChatWithUs(dropdown)" [hasDivider]="true">
        <rt-icon prefix name="support" size="medium" />
        <span margin-left-small-x>{{ 'app.support_fab.contact_support' | translate }}</span>
        @if (isContactSupportUnread()) {
          <rt-dot suffix color="notifications" size="small" class="contact-support-dot" />
        }
      </rt-dropdown-item>
    }

    @if (showContactSales()) {
      <rt-dropdown-item (click)="onContactSales(dropdown)" [hasDivider]="true">
        <rt-icon prefix name="support-agent" size="medium" />
        <span margin-left-small-x>{{ 'app.support_fab.contact_sales' | translate }}</span>
      </rt-dropdown-item>
    }

    @if (showCopyDebugInfo()) {
      <rt-dropdown-item
        class="debug-info-item"
        [hasDivider]="true"
        (click)="onCopyDebugInfo(dropdown)"
      >
        <rt-icon prefix name="content-copy" size="medium" style="visibility: hidden" />
        <span margin-left-small-x>{{ 'app.support_fab.copy_debug_info' | translate }}</span>
      </rt-dropdown-item>
    }
  </rt-dropdown>
</ng-template>
